import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function topUp(body) {
  const { data } = await axios.post(routes.topUp, {
    ...body
  }, AXIOS_DEFAULT_CONFIG);

  return data;
}
